type ActivityRow = {
  lastMessage?: { createdAt: Date | string } | null;
  lastReaction?: { createdAt: Date | string } | null;
  updatedAt: Date | string;
};

const toDate = (value: Date | string) =>
  value instanceof Date ? value : new Date(value);

/**
 * Whether the row's line should show its reaction rather than its last
 * message: only while nothing newer has been sent (an optimistic send on the
 * client takes the line back before the server has said so).
 */
export function isChatListReactionCurrent(row: ActivityRow): boolean {
  if (!row.lastReaction) return false;
  if (!row.lastMessage) return true;
  return (
    toDate(row.lastReaction.createdAt).getTime() >
    toDate(row.lastMessage.createdAt).getTime()
  );
}

/**
 * When an inbox row last saw activity — its newest message, or a newer
 * reaction it previews — for its timestamp and its place in the list.
 */
export function chatListActivityAt(row: ActivityRow): Date {
  if (row.lastReaction && isChatListReactionCurrent(row)) {
    return toDate(row.lastReaction.createdAt);
  }
  return toDate(row.lastMessage?.createdAt || row.updatedAt);
}
